import React from 'react';
import { useTranslation } from 'react-i18next';

interface UserDataItemProps {
  translationKey: string;
  value?: string | null;
  className?: string;
}

export const UserDataItem: React.FC<UserDataItemProps> = ({
  translationKey,
  value,
  className = '',
}) => {
  const { t } = useTranslation('component', { keyPrefix: 'sampleDetails' });

  return (
    <div className={className}>
      <h3 className="text-base text-black font-bold">
        {t(`fields.${translationKey}`)}
      </h3>
      <p className="font-light">{value || t('unknownField')}</p>
    </div>
  );
};
